import { a as __rest } from '../../../tslib.es6.esm.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import { cn } from '../../../utils/cn.esm.js';
import { BaseInput } from '../../BaseInput/BaseInput.esm.js';
import { BaseLabel } from '../../BaseLabel/BaseLabel.esm.js';
import { useSliderA11y } from '../context/SliderA11yProvider.esm.js';
import inputStyles from './RangeInput.styles.esm.js';

const RangeInput = forwardRef((props, ref) => {
    const generatedId = useId();
    const { isSliderFocused } = useSliderA11y();
    const { id = generatedId, label = "", error, errorMessage, helperText, helperTextMessage, disabled, className = "", inverse = false, value, idHelperText, idErrorText, onChange } = props, otherProps = __rest(props, ["id", "label", "error", "errorMessage", "helperText", "helperTextMessage", "disabled", "className", "inverse", "value", "idHelperText", "idErrorText", "onChange"]);
    const { input: inputClasses, labelInner: labelInnerClasses, label: labelClasses, labelInputWrapper: labelInputWrapperClasses, wrapper: wrapperClasses, } = inputStyles({
        inverse,
        error,
        disabled,
    });
    const ariaDescribedBy = [
        error && errorMessage && `${idErrorText}-error`,
        helperText && helperTextMessage && idHelperText,
    ]
        .filter(Boolean)
        .join(" ") || undefined;
    return (jsx("div", { className: wrapperClasses(), children: jsxs("div", { className: labelInputWrapperClasses(), children: [jsx(BaseInput, Object.assign({ id: id, inverse: inverse, "aria-describedby": ariaDescribedBy, className: cn(inputClasses({ class: className })), disabled: disabled, ref: ref, onChange: onChange, value: value, "aria-hidden": isSliderFocused || undefined, tabIndex: isSliderFocused ? -1 : undefined }, otherProps)), jsx(BaseLabel, { id: `${id}-label`, htmlFor: id, inverse: inverse, disabled: disabled, className: cn(labelClasses(), labelInnerClasses()), children: label })] }) }));
});

export { RangeInput };
